
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'TwoColumnsBlock',
  data: function () {
    const gridCols = this.extras.totalCols;
    const { gap } = this.values;
    return {
      gridCols: gridCols,
      gap: gap,
    };
  },

  computed: {
    setGap: function () {
      return this?.values?.gap;
    },
  },
  methods: {
    setColWidth: function (width) {
      return ((width || 2) / (this?.extras?.totalCols || 12)) * 100;
    },
  },
});
